import { render, staticRenderFns } from "./ProfileQualification.vue?vue&type=template&id=385978bf"
import script from "./ProfileQualification.vue?vue&type=script&lang=js"
export * from "./ProfileQualification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports